import { getHsvGolden } from 'golden-colors';

export class ColorGenerator {
	private static colors: string[] = [
		'#0086C0',
		'#FAA1F1',
		'#B60707',
		'#FDAB3D',
		'#784BD1',
		'#C4C4C4',
		'#FF158A',
		'#01C8B5',
		'#7E3B8A',
		'#FF7575',
		'#9AADBD',
		'#225091',
		'#808080',
		'#44179C',
		'#68A1BD',
		'#579BFC',
		'#FFADAD',
		'#037F4C',
		'#FFCB00',
		'#7F5347',
		'#333333',
		'#860069',
		'#CAB641',
		'#FF5AC4',
		'#00C875',
		'#66CCFF',
		'#A661E0',
		'#5559DF',
		'#FA31BA',
		'#9CD326',
		'#FF642E'
	];

	public static getGoldenRatioColor() {
		return getHsvGolden(0.7, 0.8).toRgbString();
	}

	public static getRandomColor() {
		let index = 0;
		return () => {
			const c = this.colors[index];
			index = index === this.colors.length - 1 ? 0 : index + 1;
			return c;
		};
	}

	public static getPersistentColorByString(input) {
		const number = input
			.split('')
			.map(letter => letter.charCodeAt(0))
			.reduce((partialSum, a) => partialSum + a, 0);

		return this.colors[number % this.colors.length];
	}
}
